/**
 * The environment tags used by click up syncs.
 */
export enum ClickUpEnvTags {
	env = "env"
}
